export const palette = {
  primary: '#063932',
  primaryDark: '#6BBBB1',
  primaryLight: '#A2B9B5',
  primaryInk: '#0A180E',
  warning: '#EC8D18',
  danger: '#FF0000',
} as const;

/**
 * Convert a hex color (#RGB or #RRGGBB) to an rgba() string.
 * Alpha is clamped to [0, 1].
 */
export function withAlpha(hex: string, alpha: number): string {
  const a = Math.max(0, Math.min(1, alpha));
  const normalized = hex.replace('#', '').trim();

  const full =
    normalized.length === 3
      ? normalized
          .split('')
          .map((c) => c + c)
          .join('')
      : normalized;

  if (full.length !== 6) return hex;

  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);

  if ([r, g, b].some((n) => Number.isNaN(n))) return hex;

  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

